
































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {DebtPostOffice} from "@/interfaces/entity";
import {ReceiptPostOfficeStore} from "@/modules/receiptsexpenses/receiptpostoffice/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import moment from "moment";
import {FORMAT_DATE_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Ngày phát hành",
        dataIndex: "billLading.ladingDate",
        key: "ladingDate",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: 'ladingDate'}
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true
    },
    // {
    //   title: "Thu tiền NN",
    //   dataIndex: "billLading.receiverCollect",
    //   key: "receiverCollect",
    //   scopedSlots: {customRender: 'receiverCollect'},
    // },
    {
        title: "Tổng thu",
        dataIndex: "money",
        key: "money",
        scopedSlots: {customRender: 'money'},
        width: 120,
        ellipsis: true
    },
    {
        title: "Bưu cục",
        dataIndex: "postOfficeDebt.name",
        key: "postOfficeName",
        width: 150,
        ellipsis: true
    },
    {
        title: "TT.Thu tiền",
        dataIndex: "billLading.collectDelivery",
        key: "collectDelivery",
        scopedSlots: {customRender: "collectDelivery"},
        width: 120,
        ellipsis: true
    },
    {
        title: "Ngày thu tiền",
        dataIndex: "billLading.payCollectUpdateBy",
        key: "collectDeliveryDate",
        scopedSlots: {customRender: "collectDeliveryDate"},
        width: 150,
        ellipsis: true
    }
];
@Component({
    name: "ReceiptPostOfficeTable",
    components: {LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly debtPostOffices!: Array<DebtPostOffice>;
    columns = columns;
    moment = moment;
    FormatDate = FORMAT_DATE_PICKER;

    get pagination() {
        return {
            current: ReceiptPostOfficeStore.meta.page,
            pageSize: ReceiptPostOfficeStore.meta.limit,
            total: ReceiptPostOfficeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ReceiptPostOfficeStore.updateParamsDebtPostOffice({
            ...ReceiptPostOfficeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ReceiptPostOfficeStore.listDebtPostOffice(ReceiptPostOfficeStore.params);
    }
}
